import { LoadingOutlined } from 'components/Shared/Icons';

import styles from './styles.module.css';

type LoadingMessageProps = {
  open: boolean;
};

const LoadingMessage = ({ open }: LoadingMessageProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.container}>
      <LoadingOutlined className={styles.icon} />
      <p className={styles.text}>Obtendo informações</p>
    </div>
  );
};

export default LoadingMessage;
